<script setup lang="ts">
  import { Tooltip } from "@/components/ui/tooltip";

  const TOOLTIP_THRESHOLD = 48;

  const props = withDefaults(defineProps<{ name: string; subtitle?: string | null; nameDataCy?: string }>(), {
    subtitle: null,
    nameDataCy: undefined,
  });
</script>

<template>
  <div class="flex min-w-0 items-center gap-3">
    <span
      v-if="$slots.leading"
      class="flex min-w-5 shrink-0 justify-center">
      <slot name="leading" />
    </span>
    <div class="flex min-w-0 flex-col">
      <div class="flex min-w-0 items-center gap-2">
        <Tooltip
          :content="props.name"
          :disabled="(props.name?.length ?? 0) <= TOOLTIP_THRESHOLD">
          <span
            class="truncate text-sm font-medium text-primary"
            :data-cy="props.nameDataCy">
            {{ props.name }}
          </span>
        </Tooltip>
        <slot />
      </div>
      <span
        v-if="props.subtitle"
        class="truncate text-13 text-foreground-subtle"
        :title="props.subtitle">
        {{ props.subtitle }}
      </span>
    </div>
  </div>
</template>
